module.exports = __webpack_public_path__ + "img/qr_code_new_wechat.65a3156c.jpeg";